var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 5.8V6.81333H6.0701C4.82351 6.81333 3.85977 7.8844 4.0168 9.0953L4.94531 16.25H19.0553L19.9832 9.0953C20.1402 7.8844 19.1765 6.81333 17.9299 6.81333H15.75V5.8C15.75 3.70132 14.0711 2 12 2C9.92893 2 8.25 3.70132 8.25 5.8ZM12 3.52C13.2426 3.52 14.25 4.54079 14.25 5.8V6.81333H9.75V5.8C9.75 4.54079 10.7574 3.52 12 3.52Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8608 17.75H5.13919L5.33095 19.2286C5.46225 20.2411 6.34194 21 7.38425 21H16.6158C17.6581 21 18.5377 20.2411 18.669 19.2286L18.8608 17.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag16);
export default __webpack_public_path__ + "static/media/shopping-bag-16.0fcc7769699820ddbb77c4ca1e587864.svg";
export { ForwardRef as ReactComponent };